/* Global settings for the application */

export const GLOBAL_SETTINGS = {
  delayBeforeNextQuestion: 1000,
};
